import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import { GiCancel } from 'react-icons/gi';
import { IoIosSave } from 'react-icons/io';
import Select from 'react-select';

const AddUser = ({ isVisible = true, onClose }) => {
    const [roles, setRoles] = useState([]);
    const [inputValueRole, setValueRole] = useState('');
    const [selectedValueRole, setSelectedValueRole] = useState(null);
    const [loading, setLoading] = useState(false);

    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [agences, setAgences] = useState([]);
    const [selectedAgence, setSelectedAgence] = useState(null);
    const [inputValueAgence, setValueAgence] = useState('');

    const [user, setUser] = useState({
        id: '',
        username: '',
        nom: '',
        password: '',
        password_confirmation: '',
        role: '',
        agence:''

    });
    const handleInputChangeAgence = value => {
        setValueAgence(value);
    };

    // handle selection


    // handle selection
    const handleChangeAgence = value => {
        setSelectedAgence(value);
        setUser({ ...user, agence: value.id });

    }

    const navigate = useNavigate();
  // handle input change event
  const handleInputChangeRole = value => {
    setValueRole(value);
  };

  // handle selection
  const handleChangeRole = value => {
    setSelectedValueRole(value);
    setUser({ ...user, role: value.id })
  }

    const getAgences = () => {
        axiosClient.get('/agences')
            .then((data) => {
                setAgences(data.data.agences);
            })
    }

    const getRoles = () => {
        axiosClient.get('/roles')
          .then((data) => {
            setRoles(data.data.roles);
          })
      }

    useEffect(() => {
        getRoles();
        getAgences();
    }, []);


    

    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/user/save', user)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                toast.success('Opération effectuée avec succès!', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                    theme: "light",
                });

                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Une erreur est survenue!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }

    if (!isVisible) {
        return null
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col w-auto md:w-1/2 lg:w-1/2 xl:w-1/2 bg-white lg:p-10 xl:p-10  p-2 md:p-10  rounded-xl'>
                        <div className=''>
                            <Header title="Ajouter un utilisateur" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        {loading ? <Loading /> :
                            <>
                                <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap gap-3'>
                                    <div className='flex-col w-full justify-evenly '>
                                        <div className='mr-2'>
                                            <Input label="Username" type="text" value={user.username} onChange={ev => setUser({ ...user, username: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Nom" type="text" value={user.nom} onChange={ev => setUser({ ...user, nom: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Mots de passe" type="password" value={user.password} onChange={ev => setUser({ ...user, password: ev.target.value })} required="required" />
                                        </div>
                                        <div className='mr-2'>
                                            <Input label="Confirmater le mots de passe" type="password" value={user.password_confirmation} onChange={ev => setUser({ ...user, password_confirmation: ev.target.value })} required="required" />
                                        </div>
                                        

                                    </div>
                                    <div className='flex-col w-full justify-evenly '>
                                        
                                        <div className='flex-col w-full justify-evenly '>
                                            <div className="flex-col w-full">
                                                <label className="block text-sm font-medium leading-6 text-gray-900">Agence <span className='text-red-500'> *</span></label>
                                                <Select className='mt-4 outline-1 ' placeholder="Selectionner un agence" cacheOptions defaultOptions value={selectedAgence} getOptionLabel={e => e.nom} getOptionValue={e => e.id} options={agences} onInputChange={handleInputChangeAgence} onChange={handleChangeAgence} />
                                            </div>
                                        </div>
                                        <div className='flex-col w-full justify-evenly '>
                                            <div className="flex-col w-full">
                                                <label className="block text-sm font-medium leading-6 text-gray-900">Role <span className='text-red-500'> *</span></label>
                                                <Select className='mt-4 outline-1 ' placeholder="Selectionner un role" cacheOptions defaultOptions value={selectedValueRole} getOptionLabel={e => e.name} getOptionValue={e => e.id} options={roles} onInputChange={handleInputChangeRole} onChange={handleChangeRole} />
                                            </div>
                                        </div>
                                        

                                    </div>

                                </div>
                            </>
                        }

                        <div className='flex  justify-end items-end'>
                            <div className=' flex gap-3 m-2  justify-between'>
                                <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AddUser